import * as THREE from 'three';
import EventDispatcher from "../common/EventDispatcher";
import {
    Global
} from "../common/global";
import * as CANNON from 'cannon';
import gsap from 'gsap';
import {
    CustomEase
} from 'gsap/all';

const BALL_RADIUS=0.12688752645712992;

export default class Ball {
    constructor(scene) {
        this.scene = scene;
        this.raycaster = new THREE.Raycaster(); // Initialize the raycaster
        this.previousPosition = new THREE.Vector3(); // Store the previous position of the ball
        this.onEvents = this.onEvents.bind(this);
    }

    init() {
        this.events = EventDispatcher.getObj();

        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.addEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.addEventListener("GAME_EVENTS", this.onEvents);

        this.canCheckForGoal = false;
        this.canCheckRaycaster = false;
        this.kickFinished = false;
        this.kickStarted = false;
    }

    onEvents(data) {
        switch (data['message']['event_type']) {
            case "create_scene":
                this.addBall();
                break;
            case "update":
                this.update(data['message']['data']);
                break;
            case "launch_ball":
                this.launchBall(data['message']['data']);
                break;
            case "assign_position":
                this.placeBall(data['message']['data']);
                break;
            case "dispose":
                this.dispose();
                break;
        }
    }

    addBall() {
        this.ball = Global.assets['glbs'][`ball`]['asset'].scene;
        this.scene.add(this.ball);


        Global.assets['textures'][`shadow`]['asset'].colorSpace = THREE.SRGBColorSpace;

        this.shadow = new THREE.Mesh(
            new THREE.PlaneGeometry(0.2, 0.1),
            new THREE.MeshBasicMaterial({
                side: THREE.DoubleSide,
                map: Global.assets['textures'][`shadow`]['asset'],
                transparent: true,
                opacity: 0.25
            })
        );
        this.shadow.rotation.x = Math.PI / 2;
        this.scene.add(this.shadow);

        const ballShape = new CANNON.Sphere(BALL_RADIUS);
        this.ballBody = new CANNON.Body({
            mass: 1,
            shape: ballShape,
            material: Global.ballMaterial,
            position: new CANNON.Vec3(0, 0, 0)
        });
        this.scene.world.addBody(this.ballBody);
        this.ballBody.addEventListener("collide", (event) => {
            if (!this.canCheckForGoal) return;

            this.canCheckRaycaster = false;
            if (event.body.material === Global.netMaterial && this.ballBody.position.z > 0.4) {
                this.events.dispatchEvent({
                    type: "CAMERA_EVENTS",
                    message: {
                        "event_type": "shake_camera",
                        data: {
                            "shake_fact": 0.2,
                            "shake_time": 0.3
                        }
                    }
                });
            }
            if (event.body.material === Global.netMaterial2) {
                this.kickFinished = true;
                this.canCheckForGoal = false;
                this.isGoal = true;
            
                // this.events.dispatchEvent({
                //     type: "CAMERA_EVENTS",
                //     message: {
                //         "event_type": "shake_camera",
                //         data: {
                //             "shake_fact": 1.3,
                //             "shake_time": 0.25
                //         }
                //     }
                // });

                this.events.dispatchEvent({
                    type: "GAME_EVENTS",
                    message: {
                        "event_type": "goal",
                        data: {}
                    }
                });
            }
            this.stopBallMove(event);


        });

        this.ball.traverse((child) => {
            if (!child.material) return;

            child.material.envMap = Global.envMap;
            child.material.envMapIntensity = 2;
            child.material.roughness = 0.5;
        });
    }
    stopBallMove(event) {
        if (this.launchTwn) {


            this.launchTwn && this.launchTwn.kill();
            this.launchTwn = null;

            const contactNormal = event.contact.ni;
            const relativeVelocity = event.contact.getImpactVelocityAlongNormal();
            const forceMagnitude = Math.abs(relativeVelocity) * 10;

            const reactionForce = new CANNON.Vec3(
                contactNormal.x * forceMagnitude,
                contactNormal.y * forceMagnitude + 100,
                contactNormal.z * forceMagnitude
            );

            this.ballBody.applyForce(reactionForce, this.ballBody.position);

            const spinMagnitude = 5;
            this.ballBody.angularVelocity.set(
                contactNormal.y * spinMagnitude,
                -contactNormal.x * spinMagnitude,
                0
            );
        }
    }

    placeBall(data) {
        const {
            x,
            y,
            z
        } = data['position'];

        this.ballBody.angularVelocity.set(0, 0, 0);
        this.ballBody.velocity.set(0, 0, 0)
        this.ballBody.position.set(x, y, z);
        this.kickStarted = false;
    }

    update() {
        if (this.ball && this.ballBody) {
            this.ball.position.copy(this.ballBody.position);
            this.ball.quaternion.copy(this.ballBody.quaternion);
            this.shadow.position.set(this.ball.position.x, .001, this.ball.position.z);

            // Update the previous position and check for intersections
            this.ball.updateMatrixWorld();

            if (this.canCheckRaycaster)
                this.checkForIntersections();
        }
        if (this.kickStarted) {
            this.events.dispatchEvent({
                type: "PLAYER_EVENTS",
                message: {
                    "event_type": "move_ball",
                    data: {
                        'position': this.endPoint, //this.ballBody.position,//new THREE.Vector3(-1, 1, -0.6),
                        'lerpFact': Math.max(0.01, 1 - this.launchVal.progress)
                    }
                }
            });
            //
        }
    }

    checkForIntersections() {
        const direction = new THREE.Vector3().subVectors(this.ball.position, this.previousPosition);
        this.raycaster.ray.origin.copy(this.ballBody.position);
        this.raycaster.ray.direction.copy(direction); //new THREE.Vector3(0,0,-1));
        const intersectableObjects = this.scene.children.filter(child => child.userData.canCheckIntersects);
        const intersects = this.raycaster.intersectObjects(intersectableObjects, true);

        if (intersects.length > 0) {



            let topLevelParent = intersects[0].object;
            while (topLevelParent.parent && topLevelParent.parent !== this.scene) {
                topLevelParent = topLevelParent.parent;
            }
            if (topLevelParent.visible) {
                this.kickFinished = true;
                this.canCheckForGoal = false;
                this.canCheckRaycaster = false;
                this.events.dispatchEvent({
                    type: "PLAYER_EVENTS",
                    message: {
                        "event_type": "defend",
                        data: {
                            itemType: topLevelParent.userData.itemType
                        }
                    }
                });
                this.launchTwn && this.launchTwn.kill();
                this.ballBody.velocity.set(0, 0, 0);
                this.ballBody.angularVelocity.set(-20, 0, 0);
            }

        }
        this.previousPosition.copy(this.ball.position);
    }


    launchBall(data) {
        this.kickFinished = false;
        this.canCheckForGoal = true;
        this.canCheckRaycaster = true;
        this.launchVal = {
            progress: (0.2 - .01 * Global.xPadd * .5 * data['swipeDir']) * 0
        };
        this.ballBody.angularVelocity.set(25, Math.max(10, Math.abs(data['curve_fact']) * 20), 0);
        this.ballBody.updateMassProperties();
        CustomEase.create("freeKickEase", "M0,0 C0.1,0 1,1 0.5,0.0");

        this.kickStarted = true;
        const pathLength = Global.ballPath.getLength();
        const startPoint = Global.ballPath.points[0];
        this.endPoint = Global.ballPath.points[Global.ballPath.points.length - 1];
        const straightLineDistance = startPoint.distanceTo(this.endPoint);
        const curvatureFactor = pathLength / straightLineDistance;
        const baseSpeed = 10;
        const duration = (pathLength * curvatureFactor) / baseSpeed;

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'kick'
                }
            }
        });
        this.launchTwn = gsap.to(this.launchVal, {
            progress: 1.05,
            duration: duration,
            onUpdate: function () {

                if (this.launchVal.progress < 1) {
                    this.ballBody.position.copy(this.getPositionAlongPath(this.launchVal.progress));
                } else {
                    this.launchTwn && this.launchTwn.kill();
                    this.ballBody.velocity.set(0, 0, 0);
                    // this.ballBody.angularVelocity.set(0, 0, -20);
                }
            }.bind(this),
            onComplete: function () {
                this.ballBody.angularVelocity.set(0, 0, 0);

            }.bind(this)
        });
        this.events.dispatchEvent({
            type: "CAMERA_EVENTS",
            message: {
                "event_type": "camera_pan_start",
                data: {}
            }
        });
        setTimeout(() => {
            if (!this.kickFinished) {
                this.events.dispatchEvent({
                    type: "PLAYER_EVENTS",
                    message: {
                        "event_type": "retry",
                        data: {

                        }
                    }
                });
            }
        }, 4000)
    }

    getPositionAlongPath(progress) {
        return Global.ballPath.getPointAt(progress);
    }

    dispose() {
        // Cleanup logic

        if (this.ball) {
            this.ball.traverse((child) => {
                if (child.isMesh) {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach((material) => material.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                }
            });
            this.scene.remove(this.ball);
            this.ball = null;
        }
        this.events.removeEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.removeEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.removeEventListener("GAME_EVENTS", this.onEvents);
        // this.events=null;
    }
}